import * as Yup from 'yup';
import i18n from 'i18n';

const vendorBusinessDetailsFormSchemaWrapper = (categoryList, isBusinessName) => {
    const vendorBusinessDetailsFormSchema = Yup.object()
        .shape({
            WebstoreName: Yup.string()
                .max(
                    120,
                    i18n.t('Forms.Validation.CannotExceedCharacterLimit', {
                        characterLimit: '120',
                    })
                )
                .matches(
                    /^(?!\s)(?!.*\s$)/,
                    i18n.t('Forms.BusinessInformation.WebstoreNameValidation')
                )
                .nullable()
                .required(
                    i18n.t('Forms.Validation.FieldRequired', {
                        field: isBusinessName
                            ? i18n.t('Forms.EditBasics.BusinessNameLabel')
                            : i18n.t('Forms.Labels.WebstoreName'),
                    })
                ),
            VendorCategoryId: Yup.string()
                .label(i18n.t('Forms.Labels.VendorCategory'))
                .nullable()
                .min(1, i18n.t('Forms.Validation.VendorCategory'))
                .required(
                    i18n.t('Forms.Validation.FieldRequired', {
                        field: i18n.t('Forms.Labels.VendorCategory'),
                    })
                ),
            VendorSubCategoryIds: Yup.object()
                .shape({
                    dynamicKeys: Yup.lazy((value) =>
                        Yup.object().shape(
                            Object.keys(value || {}).reduce((acc, key) => {
                                if (/^\d+$/.test(key)) {
                                    acc[key] = Yup.array().of(Yup.number()).nullable();
                                }
                                return acc;
                            }, {})
                        )
                    ),
                })
                .label(i18n.t('Forms.Labels.VendorSubCategory'))
                .nullable()
                .test(
                    'checkSubCategoriesBelongToCategory',
                    'vendor subcategory field must have at least 1 option selected',
                    async function (value) {
                        const { createError, path, parent } = this;
                        const selectedWebstoreId = parent.VendorCategoryId;

                        if (selectedWebstoreId && value) {
                            const category = categoryList.filter((x) =>
                                selectedWebstoreId
                                    .split(',')
                                    .map((item) => parseFloat(item.trim()))
                                    .includes(x.id)
                            );

                            for (let item of category) {
                                if (item) {
                                    const validSubcategoryIds = item.subCategories.map((x) => x.id);

                                    if (value[item.id] && value[item.id].length === 0) {
                                        return createError({
                                            path: `${path}.${item.id}`,
                                            message:
                                                'vendor subcategory field must have at least 1 option selected',
                                        });
                                    }

                                    const selectedSubcategories = value[item.id];
                                    const invalidSubcategories = selectedSubcategories?.some(
                                        (subCategoryId) =>
                                            !validSubcategoryIds.includes(subCategoryId)
                                    );

                                    if (invalidSubcategories) {
                                        return createError({
                                            path: `${path}.${item.id}`,
                                            message:
                                                'vendor subcategory field must have at least 1 option selected',
                                        });
                                    }
                                }
                            }
                        }
                        return true;
                    }
                )
                .required(
                    i18n.t('Forms.Validation.FieldRequired', {
                        field: i18n.t('Forms.Labels.VendorSubCategory'),
                    })
                ),
        })
        .required();

    return vendorBusinessDetailsFormSchema;
};

export { vendorBusinessDetailsFormSchemaWrapper };
